<header id="app-header">
  <div class="compound-navbar-container">
    <nav class="compound-top-navbar" aria-label="Top level">
      <div class="container g-5">
        <div class="compound-top-navbar-left">
          <ds-link queryParamsHandling="preserve" [standalone]="true"  class="top-nav-logo-link">
            <img
              class="top-navbar-logo-img"
              src="/static/assets/images/level-access-logo-new.png"
              srcset="/static/assets/images/level-access-logo-new.png 1x, /static/assets/images/level-access-logo-new@2x.png 2x"
              alt="Logo - go to the home page"
            />
          </ds-link>
        </div>
      </div>
    </nav>
  </div>
</header>
